import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _ClinicalDocument } from '../../../../../../core/services/dataBean/EntityCatalogVdos';
import { toast } from 'react-toastify';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectorHealthEntryPointTypeConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ClinicalDocument);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getLista = () => {
        instance.getHealthEntryPointTypeConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) });
    };

    return (
        <>
            <label>{label ?? "Punto de Entrada a la Institución"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null
                setValue(valor)
            }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
